export default __webpack_public_path__ + "static/media/antp_Nom012_BannerContenido.f8a84033.png";